import React from 'react';
import axios from 'axios';
import moment from 'moment';

import {
    Button,
    Checkbox,
    Divider,
    Form,
    Grid,
    Header,
    Icon, Label, Message,
    Popup,
    Radio,
    Table
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment';

import request from '../../util/request';
import { fetchAcademicYears, fetchCountries, fetchCantonss, fetchMunicipality, fetchStudyCycle, fetchStudyType, fetchSPSemesters, fetchStudyYears } from '../../Lookups/util';
import {IconHeader, IconHeaderP, IconRight} from '../../Professor/ProfessorInputGrades/css';
import _ from "lodash";
import { DateTimePicker } from 'react-widgets';
import {ExportReactCSV} from "../../util/ExportCSV";
import SearchTableData from "../../util/SearchTableData";


const obj = {};
const fetchStudyPrograms = () => axios.post('study-programs/filter', { ...obj });

export default class FilterData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            // filters
            // PLACE
            countryF: [],
            cantonF: [],
            municipalityF: [],

            // BASIC INFO
            citizenshipF: [],
            nationalityF: [],
            genderF: [],
            youngerThanF: null,

            // YEAR
            academicYearF: null,
            semesterF: [],
            studyYearF: [],
            startDateF: null,
            endDateF: null,

            // STUDY PROGRAM
            studyProgramBasicF: [],
            studyProgramF: [],

            // STUDY
            studyTypeF: [],
            cycleF: [],
            repeatingStudyYearF: null,
            repeatingStudyYearsF: null,
            gradStudentsF: null,
            showGraduatedStudentsF: null,

            // QUESTIONNAIRE
            questionnaireNameF: null,
            roleF: [],
            courseF: [],
            personF: [],

            // additional data
            jmbgA: false,
            currentResidenceA: false,
            residenceA: false,
            averageGradeA: false,
            studyYearA: false,
            semesterA: false,
            phoneNumberA: false,
            eMailA: false,
            studyProgramA: false,
            cycleA: false,
            commentA: false,
            reasonOfPauseA: false,
            documentDateA: false,
            dateOfRequestA: false,
            documentNumberA: false,
            pauseSemestersA: false,
            universityA: false,
            facultyA: false,
            countryA: false,
            mobilitySemestersA: false,
            studyProgramTitleA: false,

            // filter groups
            placeFilterItems: [],
            basicFilterItems: [],
            yearFilterItems: [],
            studyProgramFilterItems: [],
            studyFilterItems: [],
            questionnaireFilterItems: [],
            questionnaireFilterItems2: [],

            // additional data groups
            additionalDataItems: [],

            // loaders
            loaderA: false, // doesn't show additional data list until it's fully loaded
            loaderF: false, // doesn't show filter list until it's fully loaded
            showTableDataLoader: false, // doesn't show table until it's fully loaded
            getDataLoader: false, // loader icon when getting table data
            showFilters: true, // open filters component
            showAdditionalData: true, // open additional data component

            tableData: [],
            additionalDataDTO: null,

            column: null,
            direction: null,
            clickedColumn:'',

            results: []
        };

        this.getFilterData = this.getFilterData.bind(this);
        this.createFilterComponent = this.createFilterComponent.bind(this);
        this.createTableComponent = this.createTableComponent.bind(this);
        this.createAdditionalDataComponent = this.createAdditionalDataComponent.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);

        // filter data
        this.getAcademicYears = this.getAcademicYears.bind(this);
        this.getCountries = this.getCountries.bind(this);
        this.getCantons = this.getCantons.bind(this);
        this.getMunicipalities = this.getMunicipalities.bind(this);
        this.getGenders = this.getGenders.bind(this);
        this.getAges = this.getAges.bind(this);
        this.getStudyProgramBasics = this.getStudyProgramBasics.bind(this);
        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
        this.getStudyYears = this.getStudyYears.bind(this);
        this.getStartDate = this.getStartDate.bind(this);
        this.getEndDate = this.getEndDate.bind(this);
        this.getStudyTypes = this.getStudyTypes.bind(this);
        this.getCitizenships = this.getCitizenships.bind(this);
        this.getNationalities = this.getNationalities.bind(this);
        this.getCycles = this.getCycles.bind(this);
        this.getRepetitions = this.getRepetitions.bind(this);
        this.getYearsRepetitions = this.getYearsRepetitions.bind(this);
        this.getGradStudents = this.getGradStudents.bind(this);
        this.getShowGraduatedStudentsOptions = this.getShowGraduatedStudentsOptions.bind(this);
        this.getQuestionnaires = this.getQuestionnaires.bind(this);
        this.getQuestionnaireRoles = this.getQuestionnaireRoles.bind(this);
        this.getAcademicStaff = this.getAcademicStaff.bind(this);
        this.getCourses = this.getCourses.bind(this);

        // submit
        this.submitTableData = this.submitTableData.bind(this);
        this.submitDownloadData = this.submitDownloadData.bind(this);
        this.headersForExport = this.headersForExport.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);

    }

    handleSort = (clickedColumn) => {
        return () => {
            const {column, direction, tableData} = this.state;
            if (column !== clickedColumn) {
                this.setState({
                    column: clickedColumn,
                    tableData: _.sortBy(tableData, [clickedColumn]),
                    direction: 'ascending',
                })

                return
            }

            this.setState({
                tableData: tableData.reverse(),
                direction: direction === 'ascending' ? 'descending' : 'ascending',
            })
        };
    }

    componentWillMount() {
        this.getFilterData(this.props.filters);
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ additionalDataItems: this.props.additionalData, loaderA: true });
    }

    submitTableData() {
        this.setState({ showTableDataLoader: false, getDataLoader: true });

        const dataToSubmit = {
            reportSection: {
                id: this.props.reportTypeId
            },
            report: {
                id: this.props.report
            },
            filterDTO: {
                // PLACE
                countryF: this.state.countryF,
                cantonF: this.state.cantonF,
                municipalityF: this.state.municipalityF,

                // BASIC INFO
                citizenshipF: this.state.citizenshipF,
                nationalityF: this.state.nationalityF,
                genderF: this.state.genderF,
                youngerThanF: this.state.youngerThanF,

                // YEAR
                academicYearF: this.state.academicYearF,
                semesterF: this.state.semesterF,
                studyYearF: this.state.studyYearF,
                startDateF: this.state.startDateF,
                endDateF: this.state.endDateF,

                // STUDY PROGRAM
                studyProgramBasicF: this.state.studyProgramBasicF,
                studyProgramF: this.state.studyProgramF,

                // STUDY
                studyTypeF: this.state.studyTypeF,
                cycleF: this.state.cycleF,
                repeatingStudyYearF: this.state.repeatingStudyYearF,
                repeatingStudyYearsF: this.state.repeatingStudyYearsF,
                gradStudentsF: this.state.gradStudentsF,
                showGraduatedStudentsF: this.state.showGraduatedStudentsF,

                // QUESTIONNAIRE
                questionnaireNameF: this.state.questionnaireNameF,
                roleF: this.state.roleF,
                courseF: this.state.courseF,
                personF: this.state.personF,
            },
            additionalDataDTO: {
                jmbgA: this.state.jmbgA,
                currentResidenceA: this.state.currentResidenceA,
                residenceA: this.state.residenceA,
                averageGradeA: this.state.averageGradeA,
                studyYearA: this.state.studyYearA,
                semesterA: this.state.semesterA,
                phoneNumberA: this.state.phoneNumberA,
                eMailA: this.state.eMailA,
                studyProgramA: this.state.studyProgramA,
                cycleA: this.state.cycleA,
                commentA: this.state.commentA,
                reasonOfPauseA: this.state.reasonOfPauseA,
                documentDateA: this.state.documentDateA,
                dateOfRequestA: this.state.dateOfRequestA,
                documentNumberA: this.state.documentNumberA,
                pauseSemestersA: this.state.pauseSemestersA,
                universityA: this.state.universityA,
                facultyA: this.state.facultyA,
                countryA: this.state.countryA,
                mobilitySemestersA: this.state.mobilitySemestersA,
                studyTypeA: this.state.studyTypeA,
                genderA: this.state.genderA,
                studyProgramTitleA: this.state.studyProgramTitleA
            }
        };

        this.setState({ additionalDataDTO: dataToSubmit.additionalDataDTO });

        axios.post('report/table/', { ...dataToSubmit })
            .then(res => {
                this.setState({
                    showTableDataLoader: true,
                    tableData: res.data.map(el=>({
                        ...el,
                        semester:el.semester === 'ostalo'? 'apsolventski staž': el.semester,
                        // averageGrade:parseFloat(el.averageGrade),
                        droppedOutDate: el.droppedOutDate ? moment(el.droppedOutDate).format('D. M. YYYY.') : null,
                        graduationDate: el.graduationDate ? moment(el.graduationDate).format('D. M. YYYY.') : null,
                        dateOfRequest: el.dateOfRequest ? moment(el.dateOfRequest).format('D. M. YYYY.') : null,
                        documentDate: el.documentDate ? moment(el.documentDate).format('D. M. YYYY.') : null
                        })),
                    getDataLoader: false,
                    showFilters: false,
                    showAdditionalData: false
                });
            })
            .catch(err => {
                this.setState({ getDataLoader: false });
                toast('Došlo je do greške.');
                console.log('Failed to fetch report table data.');
            });

    }

    submitDownloadData() {
        // console.log('Download: ', this.state);
    }

    getFilterData(filters) {
        // eslint-disable-next-line array-callback-return
        filters.map((e) => {
            if (e._key === 'academicYearF') {
                this.getAcademicYears(e);
            } else if (e._key === 'countryF') {
                this.getCountries(e);
            } else if (e._key === 'cantonF') {
                this.getCantons(e);
            } else if (e._key === 'municipalityF') {
                this.getMunicipalities(e);
            } else if (e._key === 'genderF') {
                this.getGenders(e);
            } else if (e._key === 'youngerThanF') {
                this.getAges(e);
            } else if (e._key === 'studyProgramBasicF') {
                this.getStudyProgramBasics(e);
            } else if (e._key === 'studyProgramF') {
                this.getStudyPrograms(e);
            } else if (e._key === 'semesterF') {
                this.getSemesters(e);
            } else if (e._key === 'studyYearF') {
                this.getStudyYears(e);
            }  else if (e._key === 'startDateF') {
                this.getStartDate(e);
            }  else if (e._key === 'endDateF') {
                this.getEndDate(e);
            } else if (e._key === 'studyTypeF') {
                this.getStudyTypes(e);
            } else if (e._key === 'citizenshipF') {
                this.getCitizenships(e);
            } else if (e._key === 'nationalityF') {
                this.getNationalities(e);
            } else if (e._key === 'cycleF') {
                this.getCycles(e);
            } else if (e._key === 'repeatingStudyYearF') {
                this.getRepetitions(e);
            } else if (e._key === 'repeatingStudyYearsF') {
                this.getYearsRepetitions(e);
            } else if (e._key === 'gradStudentsF') {
                this.getGradStudents(e);
            } else if (e._key === 'showGraduatedStudentsF') {
                this.getShowGraduatedStudentsOptions(e);
            } else if (e._key === 'questionnaireNameF') {
                this.getQuestionnaires(e);
            } else if (e._key === 'roleF') {
                this.getQuestionnaireRoles(e);
            } else if (e._key === 'personF') {
                this.getAcademicStaff(e);
            } else if (e._key === 'courseF') {
                this.getCourses(e);
            }
        });

        this.setState({ loaderF: true });
    }

    getAcademicYears(filter) {
        axios.all([fetchAcademicYears()])
            .then(axios.spread((res) => {
                const data = res.data.reverse().map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                const academicYears = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    academicYearF: academicYears.data[0].value,
                    yearFilterItems: [...prevState.yearFilterItems, academicYears]
                }));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch academic years. ', err);
            });
    }

    getCountries(filter) {
        axios.all([fetchCountries()])
            .then(axios.spread((res) => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                const countries = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    placeFilterItems: [...prevState.placeFilterItems, countries]
                }));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch countries. ', err);
            });
    }

    getCantons(filter) {
        axios.all([fetchCantonss()])
            .then(axios.spread((res) => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                const cantons = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    placeFilterItems: [...prevState.placeFilterItems, cantons]
                }));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch cantons. ', err);
            });
    }

    getMunicipalities(filter) {
        axios.all([fetchMunicipality()])
            .then(axios.spread((res) => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.entity ? el.name + ' (' + el.entity._key + ')' : el.name
                }));

                const municipalities = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    placeFilterItems: [...prevState.placeFilterItems, municipalities]
                }));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch municipalities. ', err);
            });
    }

    getGenders(filter) {
        request.fetchGendersWithDefaultKeys()
            .then(({ genders }) => {
                const genders2 = {
                    data: genders,
                    filter
                };

                this.setState(prevState => ({
                    basicFilterItems: [...prevState.basicFilterItems, genders2]
                }));
            });
    }

    getAges(filter) {

        const data = [];

        for (let i = 18; i < 36; i++) {
            const temp = {
                key: i,
                value: i,
                text: i
            }

            data.push(temp);
        }

        const ages = {
            data,
            filter
        };

        this.setState(prevState => ({
            basicFilterItems: [...prevState.basicFilterItems, ages]
        }));
    }

    getStudyProgramBasics(filter) {
        axios.post('study-programs/basic', { ...obj })
            .then(res => {
                const data = res.data.filter( e => e.studyProgramBasic.archived === false ).map((el) => ({
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + ' (' + el.studyProgramBasic.studyCycles[0].displayName + ')'
                }));

                const studyProgramBasics = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    studyProgramFilterItems: [...prevState.studyProgramFilterItems, studyProgramBasics]
                }));
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });
    }

    getStudyPrograms(filter) {
        axios.all([fetchStudyPrograms()])
            .then(axios.spread((res) => {
                const data = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.studyProgramBasicName ? el.studyProgramBasicName + ' (' + el.name + ')' : el.name
                }));

                const studyPrograms = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    studyProgramFilterItems: [...prevState.studyProgramFilterItems, studyPrograms]
                }));
            }))
            .catch(err => {
                console.log('Failed to fetch study programs. ', err);
            });
    }

    getSemesters(filter) {
        axios.all([fetchSPSemesters()])
            .then(axios.spread((res) => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.name === 'ostalo'?'apsolventski staž':el.name
                }));

                const semesters = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    yearFilterItems: [...prevState.yearFilterItems, semesters]
                }));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch semesters. ', err);
            });
    }

    getStudyYears(filter) {
        axios.all([fetchStudyYears()])
            .then(axios.spread((res) => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                const studyYears = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    yearFilterItems: [...prevState.yearFilterItems, studyYears]
                }));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch study years. ', err);
            });
    }

    getStartDate(filter) {
        axios.get(`/semester/academic-year/current/`)
            .then(res => {
                const winterSemester = res.data.find(function (winter) {
                    return winter.name._key === 'winter semester';
                });

                const data = {
                    value: winterSemester.startDate,
                    key: winterSemester.startDate,
                    text: winterSemester.startDate
                }

                const startDate = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    startDateF: winterSemester.startDate,
                    yearFilterItems: [...prevState.yearFilterItems, startDate]
                }));
            })
            .catch(err => {
                console.log('Failed to fetch start date. ', err);
            });
    }

    getEndDate(filter) {
        axios.get(`/semester/academic-year/current/`)
            .then(res => {
                const summerSemester = res.data.find(function (summer) {
                    return summer.name._key === 'summer semester';
                });

                const data = {
                    value: summerSemester.endDate,
                    key: summerSemester.endDate,
                    text: summerSemester.endDate
                }

                const endDate = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    endDateF: summerSemester.endDate,
                    yearFilterItems: [...prevState.yearFilterItems, endDate]
                }));
            })
            .catch(err => {
                console.log('Failed to fetch end date. ', err);
            });
    }

    getStudyTypes(filter) {
        axios.all([fetchStudyType()])
            .then(axios.spread((res) => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                const studyTypes = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    studyFilterItems: [...prevState.studyFilterItems, studyTypes]
                }));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch study types. ', err);
            });
    }

    getCitizenships(filter) {
        request.fetchCitizenships()
            .then(data => {
                const citizenships = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    basicFilterItems: [...prevState.basicFilterItems, citizenships]
                }));
            });
    }

    getNationalities(filter) {
        request.fetchNationalitiesWithDefaultKey()
            .then(({ nationalities }) => {
                const nationalities2 = {
                    data: nationalities,
                    filter
                };

                this.setState(prevState => ({
                    basicFilterItems: [...prevState.basicFilterItems, nationalities2]
                }));
            });
    }

    getCycles(filter) {
        axios.all([fetchStudyCycle()])
            .then(axios.spread((res) => {
                const data = res.data.map((el) => ({
                    ...el,
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                const cycles = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    studyFilterItems: [...prevState.studyFilterItems, cycles]
                }));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch cycles. ', err);
            });
    }

    getRepetitions(filter) {
        const data = [
            {
                key: 1,
                value: 1,
                text: 'da'
            },
            {
                key: 0,
                value: 0,
                text: 'ne'
            }
        ];

        const repetitions = {
            data,
            filter
        };

        this.setState(prevState => ({
            studyFilterItems: [...prevState.studyFilterItems, repetitions]
        }));
    }

    getYearsRepetitions(filter) {
        const data = [
            {
                key: 1,
                value: 1,
                text: 'da'
            },
            {
                key: 0,
                value: 0,
                text: 'ne'
            }
        ];

        const yearsRepetitions = {
            data,
            filter
        };

        this.setState(prevState => ({
            studyFilterItems: [...prevState.studyFilterItems, yearsRepetitions]
        }));
    }

    getGradStudents(filter) {
        const data = [
            {
                key: 1,
                value: 1,
                text: 'da'
            },
            {
                key: 0,
                value: 0,
                text: 'ne'
            }
        ];

        const gradStudents = {
            data,
            filter
        };

        this.setState(prevState => ({
            studyFilterItems: [...prevState.studyFilterItems, gradStudents]
        }));
    }

    getShowGraduatedStudentsOptions(filter) {
        const data = [
            {
                key: 1,
                value: 1,
                text: 'da'
            },
            {
                key: 0,
                value: 0,
                text: 'ne'
            }
        ];

        const showGraduatedStudents = {
            data,
            filter
        };

        this.setState(prevState => ({
            showGraduatedStudentsF: showGraduatedStudents.data[0].value,
            studyFilterItems: [...prevState.studyFilterItems, showGraduatedStudents]
        }));
    }

    getQuestionnaireRoles(filter) {
        const data = [
            {
                key: 1,
                value: 1,
                text: 'profesor'
            },
            {
                key: 2,
                value: 2,
                text: 'asistent'
            }
        ];

        const roles = {
            data,
            filter
        };

        this.setState(prevState => ({
            questionnaireFilterItems2: [...prevState.questionnaireFilterItems2, roles]
        }));
    }

    getQuestionnaires(filter) {
        let reportTypeId = this.props.reportTypeId;

        axios.get(`/questionnaire/by-type/${reportTypeId}/`)
            .then(res => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                const questionnaires = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    questionnaireNameF: questionnaires.data[questionnaires.data.length - 1].value,
                    questionnaireFilterItems: [...prevState.questionnaireFilterItems, questionnaires]
                }));
            })
            .catch(err => {
                console.log('Failed to fetch questionnaires. ', err);
            });
    }

    getAcademicStaff(filter) {
        axios.get(`/employees/professors-and-assistants/`)
            .then(res => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.lastName + ' ' + el.firstName
                }));

                const person = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    questionnaireFilterItems2: [...prevState.questionnaireFilterItems2, person]
                }));
            })
            .catch(err => {
                console.log('Failed to fetch academic staff. ', err);
            });
    }

    getCourses(filter) {
        axios.get(`/course/basic/`)
            .then(res => {
                const data = res.data.map((el) => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                const courses = {
                    data,
                    filter
                };

                this.setState(prevState => ({
                    questionnaireFilterItems2: [...prevState.questionnaireFilterItems2, courses]
                }));
            })
            .catch(err => {
                console.log('Failed to fetch courses. ', err);
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    // eslint-disable-next-line consistent-return
    createFilterComponent(filterItem) {
        if (filterItem.filter.filterType.name === 'dropdown') {
            return (
                <Form.Field>
                    {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                    <label>{filterItem.filter.displayName}</label>
                    <Form.Dropdown
                        placeholder={'Odaberite ' + filterItem.filter.accusative}
                        value={this.state[filterItem.filter._key]}
                        onChange={this.handleInputChange}
                        name={filterItem.filter._key}
                        options={filterItem.data}
                        search
                        fluid
                        selection
                        clearable={(filterItem.filter._key !== 'questionnaireNameF')}
                        multiple={
                            (filterItem.filter._key !== 'academicYearF') &&
                            (filterItem.filter._key !== 'repeatingStudyYearF') &&
                            (filterItem.filter._key !== 'repeatingStudyYearsF') &&
                            (filterItem.filter._key !== 'gradStudentsF') &&
                            (filterItem.filter._key !== 'showGraduatedStudentsF') &&
                            (filterItem.filter._key !== 'youngerThanF') &&
                            (filterItem.filter._key !== 'questionnaireNameF')
                        }
                    />
                </Form.Field>

            );

        } else if (filterItem.filter.filterType.name === 'date picker') {
            return (
                <Form.Field
                    control={DateTimePicker}
                    label={filterItem.filter.displayName}
                    format="D. M. YYYY."
                    time={false}
                    onChange={(e)=>this.handleDateChange(filterItem.filter._key, e)}
                    value = {new Date(this.state[filterItem.filter._key])}
                    name={filterItem.filter._key}
                    style={{ borderWidth: '0px' }}
                />
            );
        } // else if (filterItem.filter.filterType.name === 'radio button') {
        //     console.log(filterItem);
        //     return (
        //         <Form>
        //             <Form.Field>
        //                 {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        //                 <label>{filterItem.filter.displayName}</label>
        //                 { filterItem.data.map((el, i) =>
        //                     (<Radio
        //                         label={el.text}
        //                         name="radioGroup"
        //                         value={el.value}
        //                         checked={this.state[filterItem.data.text] === filterItem.data.text}
        //                         onChange={!this.state[filterItem.data.text]}
        //                     />))}
        //             </Form.Field>
        //         </Form>
        //     );
        // } else if (filterItem.filter.filterType.name === 'checkbox') {
        //     return (
        //         <Form.Field>
        //             {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        //             <label>{filterItem.filter.displayName}</label>
        //             { filterItem.data.map((el, i) =>
        //                 (<Checkbox
        //                     label={el.text}
        //                     value={el.value}
        //                     // onChange={(e) => this.setState({ mandatory: !this.state.mandatory })}
        //                 />))}
        //         </Form.Field>
        //     );
        // } else if (filterItem.filter.filterType.name === 'slider') {
        //     console.log('slider');
        // }
    }

    getResults(results) {
        this.setState({ results });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.tableData;
    }

    createTableComponent() {
        const additionalData = this.state.additionalDataDTO;
        // eslint-disable-next-line prefer-destructuring
        const tableData = this.state.tableData;
        const direction = this.state.direction;
        const column = this.state.column;

        return (
            this.getDataToRender().length > 0 ?
                <Table celled selectable compact >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={(this.headersForExport().length -2)*3+1}>
                                        <span> {this.state.tableData && <ExportReactCSV color="green" csvData={this.state.tableData} headers={this.headersForExport()} floated="right" fileName="Izvještaj" />}
                                            <SearchTableData data={this.state.tableData} getResults={this.getResults}
                                                             filterItem={['firstName', 'lastName', 'parentName', 'jmbg', 'residence', 'semester', 'studyProgram', 'cycle', 'studyProgramTitle',
                                                             'currentResidence', 'averageGrade', 'indexNumber', 'phoneNumber', 'eMail', 'diplomaNumber', 'studyYear', 'mobilitySemesters',
                                                             'comment', 'reasonOfPause', 'documentDate', 'documentNumber', 'pauseSemesters', 'university', 'faculty', 'country', 'socialStatusType']} />
                                        </span>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                            <Table.HeaderCell colSpan={3} sorted={column === 'fullName' ? direction : null}
                                              onClick={this.handleSort('fullName')}>
                                Prezime (Ime roditelja) Ime
                                { column === 'fullName' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>

                            {additionalData.jmbgA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'jmbg' ? direction : null}
                                              onClick={this.handleSort('jmbg')}>
                                JMBG
                                { column === 'jmbg' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.residenceA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'residence' ? direction : null}
                                              onClick={this.handleSort('residence')}>
                                Mjesto prebivališta
                                { column === 'residence' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.currentResidenceA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'currentResidence' ? direction : null}
                                              onClick={this.handleSort('currentResidence')}>
                                Mjesto boravišta
                                { column === 'currentResidence' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.averageGradeA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'averageGrade' ? direction : null}
                                              onClick={this.handleSort('averageGrade')}>
                                Prosječna ocjena
                                { column === 'averageGrade' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            <Table.HeaderCell colSpan={3} sorted={column === 'indexNumber' ? direction : null}
                                              onClick={this.handleSort('indexNumber')}>
                                Broj indexa
                                { column === 'indexNumber' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>

                            {additionalData.phoneNumberA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'phoneNumber' ? direction : null}
                                              onClick={this.handleSort('phoneNumber')}>
                                Broj telefona
                                { column === 'phoneNumber' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.eMailA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'eMail' ? direction : null}
                                              onClick={this.handleSort('eMail')}>
                                e-mail
                                { column === 'eMail' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.studyYearA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'studyYear' ? direction : null}
                                              onClick={this.handleSort('studyYear')}>
                                Godina studija
                                { column === 'studyYear' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.semesterA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'semester' ? direction : null}
                                              onClick={this.handleSort('semester')}>
                                Semestar
                                { column === 'semester' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.studyProgramA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'studyProgram' ? direction : null}
                                              onClick={this.handleSort('studyProgram')}>
                                Studijski program
                                { column === 'studyProgram' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.cycleA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'cycle' ? direction : null}
                                              onClick={this.handleSort('cycle')}>
                                Ciklus
                                { column === 'cycle' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {this.props.reportName === 'Ispisani' &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'droppedOutDate' ? direction : null}
                                              onClick={this.handleSort('droppedOutDate')}>
                                Datum ispisa
                                { column === 'droppedOutDate' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {this.props.reportName === 'Diplomirani' &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'diplomaNumber' ? direction : null}
                                              onClick={this.handleSort('diplomaNumber')}>
                                Broj diplome
                                { column === 'diplomaNumber' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {this.props.reportName === 'Diplomirani' &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'graduationDate' ? direction : null}
                                              onClick={this.handleSort('graduationDate')}>
                                Datum diplomiranja
                                { column === 'graduationDate' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {this.props.reportName === 'Diplomirani' && additionalData.studyProgramTitleA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'studyProgramTitle' ? direction : null}
                                              onClick={this.handleSort('studyProgramTitle')}>
                                Stručno zvanje
                                { column === 'studyProgramTitle' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.pauseSemestersA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'pauseSemesters' ? direction : null}
                                              onClick={this.handleSort('pauseSemesters')}>
                                Pauzirani semestri
                                { column === 'pauseSemesters' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.reasonOfPauseA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'reasonOfPause' ? direction : null}
                                              onClick={this.handleSort('reasonOfPause')}>
                                Razlog zahtjeva
                                { column === 'reasonOfPause' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.dateOfRequestA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'dateOfRequest' ? direction : null}
                                              onClick={this.handleSort('dateOfRequest')}>
                                Datum zahtjeva
                                { column === 'dateOfRequest' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.documentNumberA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'documentNumber' ? direction : null}
                                              onClick={this.handleSort('documentNumber')}>
                                Broj odluke
                                { column === 'documentNumber' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.documentDateA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'documentDate' ? direction : null}
                                              onClick={this.handleSort('documentDate')}>
                                Datum odluke
                                { column === 'documentDate' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.commentA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'comment' ? direction : null}
                                              onClick={this.handleSort('comment')}>
                                Napomena
                                { column === 'comment' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.universityA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'university' ? direction : null}
                                              onClick={this.handleSort('university')}>
                                Univerzitet
                                { column === 'university' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.facultyA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'faculty' ? direction : null}
                                              onClick={this.handleSort('faculty')}>
                                Fakultet
                                { column === 'faculty' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.countryA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'country' ? direction : null}
                                              onClick={this.handleSort('country')}>
                                Država
                                { column === 'country' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {additionalData.mobilitySemestersA &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'mobilitySemesters' ? direction : null}
                                              onClick={this.handleSort('mobilitySemesters')}>
                                Semestri u kojima je student pohađao program mobilnosti
                                { column === 'mobilitySemesters' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                            {this.props.reportName === 'Socijalni status' &&
                            <Table.HeaderCell colSpan={3} sorted={column === 'socialStatusType' ? direction : null}
                                              onClick={this.handleSort('socialStatusType')}>
                                Socijalni status
                                { column === 'socialStatusType' ? direction === 'ascending' ?
                                    <i style={IconRight} className="sort amount down icon"/> :
                                    <i style={IconRight} className="sort amount up icon"/> :
                                    <i style={IconRight} className="sort icon"/>}
                            </Table.HeaderCell>}

                        </Table.Row>
                    </Table.Header>
                    <Table.Body> {this.getDataToRender().map((el, index) => (
                        <Table.Row key={index} >
                            <Table.Cell verticalAlign="middle" width={1}> {index + 1}. </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={3}> {el.fullName} </Table.Cell>
                            {additionalData.jmbgA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.jmbg} </Table.Cell>}
                            {additionalData.residenceA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.residence} </Table.Cell>}
                            {additionalData.currentResidenceA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.currentResidence} </Table.Cell>}
                            {additionalData.averageGradeA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.averageGrade !== 0 ? el.averageGrade : '' } </Table.Cell>}
                            <Table.Cell verticalAlign="middle" colSpan={3}> {el.indexNumber} </Table.Cell>
                            {additionalData.phoneNumberA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.phoneNumber} </Table.Cell>}
                            {additionalData.eMailA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.eMail} </Table.Cell>}
                            {additionalData.studyYearA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.studyYear} </Table.Cell>}
                            {additionalData.semesterA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.semester} </Table.Cell>}
                            {additionalData.studyProgramA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.studyProgram} </Table.Cell>}
                            {additionalData.cycleA && <Table.Cell verticalAlign="middle" colSpan={3}> {el.cycle} </Table.Cell>}
                            {this.props.reportName === 'Ispisani' && <Table.Cell verticalAlign="middle" colSpan={3}> { el.droppedOutDate } </Table.Cell>}
                            {this.props.reportName === 'Diplomirani' && <Table.Cell verticalAlign="middle" colSpan={3}> { el.diplomaNumber } </Table.Cell>}
                            {this.props.reportName === 'Diplomirani' && <Table.Cell verticalAlign="middle" colSpan={3}> { el.graduationDate } </Table.Cell>}
                            {this.props.reportName === 'Diplomirani' && additionalData.studyProgramTitleA && <Table.Cell colSpan={3} verticalAlign="middle"> { el.studyProgramTitle } </Table.Cell>}
                            {additionalData.pauseSemestersA && <Table.Cell colSpan={3} verticalAlign="middle"> {el.pauseSemesters} </Table.Cell>}
                            {additionalData.reasonOfPauseA && <Table.Cell colSpan={3} verticalAlign="middle"> {el.reasonOfPause} </Table.Cell>}
                            {additionalData.dateOfRequestA && <Table.Cell colSpan={3} verticalAlign="middle"> { el.dateOfRequest } </Table.Cell>}
                            {additionalData.documentNumberA && <Table.Cell colSpan={3} verticalAlign="middle"> {el.documentNumber} </Table.Cell>}
                            {additionalData.documentDateA && <Table.Cell colSpan={3} verticalAlign="middle"> { el.documentDate } </Table.Cell>}
                            {additionalData.commentA && <Table.Cell colSpan={3} verticalAlign="middle"> {el.comment} </Table.Cell>}
                            {additionalData.universityA && <Table.Cell colSpan={3} verticalAlign="middle"> {el.university} </Table.Cell>}
                            {additionalData.facultyA && <Table.Cell colSpan={3} verticalAlign="middle"> {el.faculty} </Table.Cell>}
                            {additionalData.countryA && <Table.Cell colSpan={3} verticalAlign="middle"> {el.country} </Table.Cell>}
                            {additionalData.mobilitySemestersA && <Table.Cell colSpan={3} verticalAlign="middle"> {el.mobilitySemesters} </Table.Cell>}
                            {this.props.reportName === 'Socijalni status' && <Table.Cell verticalAlign="middle" colSpan={3}> { el.socialStatusType } </Table.Cell>}
                        </Table.Row>
                    ))}
                    </Table.Body>
                </Table> : <p>Za odabrane filtere nema rezultata!</p>
        );
    }

    createAdditionalDataComponent() {
        return (
            <Form.Group>
                {this.state.additionalDataItems.map((el) =>
                (
                        <Form.Field>
                            <Checkbox
                                label={el.displayName}
                                checked={this.state[el._key]}
                                value={this.state[el._key]}
                                onChange={(e) => this.setState({ [el._key]: !this.state[el._key] })}
                            />
                        </Form.Field>
                ))}
            </Form.Group>
        );
    }

    headersForExport(){

        let headers = [];
        console.log('tableData', this.state.tableData)
        this.state.tableData.map(el => {
                if(el.firstName !== null && headers.filter(e=> e.key === 'firstName').length === 0){
                        headers.push(  { label: 'Ime', key: 'firstName' });
                }
                if(el.parentName !== null && headers.filter(e=> e.key === 'parentName').length === 0){
                    headers.push( { label: 'Ime oca', key: 'parentName' });
                }
                if(el.lastName !== null && headers.filter(e=> e.key === 'lastName').length === 0){
                    headers.push(  { label: 'Prezime', key: 'lastName' });
                }
                if(el.jmbg !== null && headers.filter(e=> e.key === 'jmbg').length === 0){
                    headers.push( { label: 'JMBG', key: 'jmbg' });
                }
                if(el.residence !== null && headers.filter(e=> e.key === 'residence').length === 0){
                    headers.push( { label: 'Prebivalište', key: 'residence' });
                }
                if(el.currentResidence !== null && headers.filter(e=> e.key === 'currentResidence').length === 0){
                    headers.push( { label: 'Boravište', key: 'currentResidence' });
                }
                if(el.averageGrade !== null && headers.filter(e=> e.key === 'averageGrade').length === 0){
                    headers.push( { label: 'Prosječna ocjena', key: 'averageGrade' });
                }
                if(el.indexNumber !== null && headers.filter(e=> e.key === 'indexNumber').length === 0){
                    headers.push( { label: 'Index', key: 'indexNumber' });
                }
                if(el.phoneNumber !== null && headers.filter(e=> e.key === 'phoneNumber').length === 0){
                    headers.push( { label: 'Broj telefona', key: 'phoneNumber' });
                }
                if(el.eMail !== null && headers.filter(e=> e.key === 'eMail').length === 0){
                    headers.push(  { label: 'e-mail', key: 'eMail' });
                }
                if(el.droppedOutDate !== null && headers.filter(e=> e.key === 'droppedOutDate').length === 0){
                    headers.push( { label: 'Datum ispisa', key: 'droppedOutDate' });
                }
                if(el.graduationDate !== null && headers.filter(e=> e.key === 'graduationDate').length === 0){
                    headers.push(  { label: 'Datum diplomiranja', key: 'graduationDate' });
                }
                if(el.diplomaNumber !== null && headers.filter(e=> e.key === 'diplomaNumber').length === 0){
                    headers.push( { label: 'Broj diplome', key: 'diplomaNumber' });
                }
                if(el.studyYear !== null && headers.filter(e=> e.key === 'studyYear').length === 0){
                    headers.push( { label: 'Godina studija', key: 'studyYear' });
                }
                if(el.semester !== null && headers.filter(e=> e.key === 'semester').length === 0){
                    headers.push( { label: 'Semestar', key: 'semester' });
                }
                if(el.studyProgram !== null && headers.filter(e=> e.key === 'studyProgram').length === 0){
                    headers.push(  { label: 'Studijski program', key: 'studyProgram' });
                }
                if(el.cycle !== null && headers.filter(e=> e.key === 'cycle').length === 0){
                    headers.push(  { label: 'Ciklus studija', key: 'cycle' });
                }
                if(el.comment !== null && headers.filter(e=> e.key === 'comment').length === 0){
                    headers.push( { label: 'Napomena', key: 'comment' });
                }
                if(el.reasonOfPause !== null && headers.filter(e=> e.key === 'reasonOfPause').length === 0){
                    headers.push( { label: 'Razlog mirovanja', key: 'reasonOfPause' });
                }
                if(el.documentDate !== null && headers.filter(e=> e.key === 'documentDate').length === 0){
                    headers.push( { label: 'Datum ', key: 'documentDate' });
                }
                if(el.dateOfRequest !== null && headers.filter(e=> e.key === 'dateOfRequest').length === 0){
                    headers.push( { label: 'Datum zahtjeva', key: 'dateOfRequest' });
                }
                if(el.documentNumber !== null && headers.filter(e=> e.key === 'documentNumber').length === 0){
                    headers.push( { label: 'Broj dokumenta', key: 'documentNumber' });
                }
                if(el.pauseSemesters !== null && headers.filter(e=> e.key === 'pauseSemesters').length === 0){
                    headers.push( { label: 'Semestar mirovanja', key: 'pauseSemesters' });
                }
                if(el.university !== null && headers.filter(e=> e.key === 'university').length === 0){
                    headers.push(  { label: 'Univerzitet', key: 'university' });
                }
                if(el.faculty !== null && headers.filter(e=> e.key === 'faculty').length === 0){
                    headers.push(  { label: 'Fakultet', key: 'faculty' });
                }
                if(el.country !== null && headers.filter(e=> e.key === 'country').length === 0){
                    headers.push( { label: 'Država', key: 'country' });
                }
                if(el.mobilitySemesters !== null && headers.filter(e=> e.key === 'mobilitySemesters').length === 0){
                    headers.push( { label: 'Semestar mobilnosti', key: 'mobilitySemesters' });
                }
                if(el.studyProgramTitle !== null && headers.filter(e=> e.key === 'studyProgramTitle').length === 0){
                    headers.push( { label: 'Titula', key: 'studyProgramTitle' });
                }
                if(el.socialStatusType !== null && headers.filter(e=> e.key === 'socialStatusType').length === 0){
                    headers.push( { label: 'Socijalni status', key: 'socialStatusType' });
                }
        }
        )

console.log('headers', headers)
        return headers;

    }

    render() {

        const { questionnaireFilterItems } = this.state;
        const { questionnaireFilterItems2 } = this.state;
        const { placeFilterItems } = this.state;
        const { basicFilterItems } = this.state;
        const { yearFilterItems } = this.state;
        const { studyProgramFilterItems } = this.state;
        const { studyFilterItems } = this.state;
        const {
            loaderA, loaderF, showTableDataLoader, showAdditionalData, showFilters, getDataLoader
        } = this.state;

        return (
            (loaderA && loaderF && <div>
                <Grid  centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <div>
                                <Header style={IconHeaderP} floated="right">
                                    <Popup
                                        trigger={
                                            <Button
                                                circular
                                                icon={!showFilters ? 'angle down' : 'angle up'}
                                                onClick={() => { this.setState({ showFilters: !showFilters }); }}
                                            />
                                        }
                                        content={!showFilters ? 'Prikaži' : 'Sakrij'}
                                        size="tiny"
                                        data-position="left center"
                                        wide
                                        position="top right"
                                    />
                                </Header>
                                <Header style={IconHeader} floated="left">
                                    <Popup
                                        trigger={<Icon circular basic="true" name="info" style={IconHeader} />}
                                        content="Odaberite stavke prema kojima želite filtrirati podatke. Od svakog ponuđenog filtera možete odabrati nijedan, jedan ili više izbora."
                                        size="tiny"
                                        data-position="left center"
                                        wide
                                        position="top right"
                                    />
                                </Header>

                                <Divider horizontal>
                                    <Header as="h4">
                                        Filteri
                                    </Header>
                                </Divider>
                                {showFilters && <Segment secondary>
                                    {questionnaireFilterItems.length > 0 &&
                                    <Form>
                                        <Divider horizontal>
                                            {/*<Header as="h6">*/}
                                            {/*    Ankete*/}
                                            {/*</Header>*/}
                                        </Divider>
                                        <Segment primary>
                                            <Form.Group widths="equal">
                                                { questionnaireFilterItems.sort((a, b) => a.filter.orderNumber - b.filter.orderNumber).map((filterItem) => this.createFilterComponent(filterItem))}
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                    }

                                    {questionnaireFilterItems2.length > 0 &&
                                    <Form>
                                        <Divider horizontal>
                                            {/*<Header as="h6">*/}
                                            {/*    Ostali podaci*/}
                                            {/*</Header>*/}
                                        </Divider>
                                        <Segment primary>
                                            <Form.Group widths="equal">
                                                { questionnaireFilterItems2.sort((a, b) => a.filter.orderNumber - b.filter.orderNumber).map((filterItem) => this.createFilterComponent(filterItem))}
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                    }

                                    {placeFilterItems.length > 0 &&
                                    <Form>
                                        <Divider horizontal>
                                            <Header as="h6">
                                                Mjesto prebivališta
                                            </Header>
                                        </Divider>
                                        <Segment primary>
                                            <Form.Group widths="equal">
                                                { placeFilterItems.sort((a, b) => a.filter.orderNumber - b.filter.orderNumber).map((filterItem) => this.createFilterComponent(filterItem))}
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                    }

                                    {basicFilterItems.length > 0 &&
                                    <Form>
                                        <Divider horizontal>
                                            <Header as="h6">
                                                Osnovni podaci
                                            </Header>
                                        </Divider>
                                        <Segment primary>
                                            <Form.Group widths="equal">
                                                { basicFilterItems.sort((a, b) => a.filter.orderNumber - b.filter.orderNumber).map((filterItem) => this.createFilterComponent(filterItem))}
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                    }

                                    {yearFilterItems.length > 0 &&
                                    <Form>
                                        <Divider horizontal>
                                            <Header as="h6">
                                                Godina studija
                                            </Header>
                                        </Divider>
                                        <Segment primary>
                                            <Form.Group widths="equal">
                                                { yearFilterItems.sort((a, b) => a.filter.orderNumber - b.filter.orderNumber).map((filterItem) => this.createFilterComponent(filterItem))}
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                    }

                                    {studyProgramFilterItems.length > 0 &&
                                    <Form>
                                        <Divider horizontal>
                                            <Header as="h6">
                                                Studijski program
                                            </Header>
                                        </Divider>
                                        <Segment primary>
                                            <Form.Group widths="equal">
                                                { studyProgramFilterItems.sort((a, b) => a.filter.orderNumber - b.filter.orderNumber).map((filterItem) => this.createFilterComponent(filterItem))}
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                    }

                                    {studyFilterItems.length > 0 &&
                                    <Form>
                                        <Divider horizontal>
                                            <Header as="h6">
                                                Studij
                                            </Header>
                                        </Divider>
                                        <Segment primary>
                                            <Form.Group widths="equal">
                                                { studyFilterItems.sort((a, b) => a.filter.orderNumber - b.filter.orderNumber).map((filterItem) => this.createFilterComponent(filterItem))}
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                    }
                                </Segment>}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <br />
                <Grid  centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <div>
                                <Header style={IconHeaderP} floated="right">
                                    <Popup
                                        trigger={
                                            <Button
                                                circular
                                                icon={!showAdditionalData ? 'angle down' : 'angle up'}
                                                onClick={() => { this.setState({ showAdditionalData: !showAdditionalData }); }}
                                            />
                                        }
                                        content={!showAdditionalData ? 'Prikaži' : 'Sakrij'}
                                        size="tiny"
                                        data-position="left center"
                                        wide
                                        position="top right"
                                    />
                                </Header>
                                <Header style={IconHeader} floated="left">
                                    <Popup
                                        trigger={<Icon circular basic="true" name="info" style={IconHeader} />}
                                        content="Odaberite koje podatke želite prikazati u izvještaju. U sadržaj izvještaja su već uključeni osnovni podaci."
                                        size="tiny"
                                        data-position="left center"
                                        wide
                                        position="top right"
                                    />
                                </Header>

                                <Divider horizontal>
                                    <Header as="h4">
                                        Sadržaj izvještaja
                                    </Header>
                                </Divider>

                                <Form>
                                    {showAdditionalData && <Segment secondary>
                                       { this.createAdditionalDataComponent() }
                                    </Segment>}
                                </Form>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid columns={1}>
                    <Grid.Row stretched>
                        <br />
                        <Grid.Column >
                            <Button style={{marginLeft: '15px', marginRight: '7px'}} loading={getDataLoader} className="ui fluid button" color="blue" onClick={this.submitTableData}>
                                <Icon name="table" />
                                Tabelarni prikaz
                            </Button>
                        </Grid.Column>

                        <br />
                    </Grid.Row>
                </Grid>

                <Divider inverted />

                {showTableDataLoader && this.createTableComponent() }

                <ToastContainer hideProgressBar />
            </div>)
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/FilterData.js